export default class CommonService {
  private t: (key: string) => string;

  constructor(t: (key: string) => string) {
    this.t = t;
  }

  timeString(time: string) {
    const [hours, minutes] = time.split(":").map(Number);

    const hourPart =
      hours > 0
        ? `${hours} ${hours === 1 ? this.t("t-hour") : this.t("t-hours")}`
        : "";
    const minutePart =
      minutes > 0
        ? `${minutes} ${
            minutes === 1 ? this.t("t-minute") : this.t("t-minutes")
          }`
        : "";

    if (hourPart && minutePart) {
      return `${hourPart} ${minutePart}`;
    } else if (hourPart) {
      return hourPart;
    } else if (minutePart) {
      return minutePart;
    } else {
      return "0 " + this.t("t-hours"); // In case the time is "00:00:00"
    }
  }

  durations(start: Date, end: Date) {
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Get the difference in milliseconds
    let diffMs = endDate.getTime() - startDate.getTime();

    // Convert milliseconds to hours and minutes
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    diffMs %= (1000 * 60 * 60 * 24);
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    diffMs %= (1000 * 60 * 60);
    const minutes = Math.floor(diffMs / (1000 * 60));

    let result = [];

    if (days > 0) {
        result.push(`${days} ${days > 1 ? this.t('t-days') : this.t('t-day')}`);
    }
    if (hours > 0) {
        result.push(`${hours} ${this.t('t-hours')}`);
    }
    if (minutes > 0) {
        result.push(`${minutes} ${this.t('t-minutes')}`);
    }

    return result.length > 0 ? result.join(" ") : `0 ${this.t('t-minutes')}`;
}
}
